<script>
    import _           from 'lodash'
    import * as api    from '../../shared/api.js'
    import Issues      from '../../shared/Issues.svelte'
    import FieldEditor from './FieldEditor.svelte'
    import FieldScope  from './FieldScope.svelte'

    export let domain    = null
    export let inventory = null
    export let place     = null
    export let latest    = false

    let detailed  = false
    let mode      = null
    let active    = null
    let tempField = null

    const AllScopes = ['SAR', 'DDR', 'RET']

    function natureGiven(it) {
        switch(it) {
            case "ID"       : return "id"
            case "NAME"     : return "nome"
            case "PHONE"    : return "telefone"
            case "EMAIL"    : return "email"
            case "UNKNOWN"  : return "genérica"
            default: return it
        }
    }

    function storageGiven(it) {
        switch(it) {
            case "PLAIN" : return "simples"
            case "SIMPLE": return "simples"
            default: return it
        }
    }

    function retentionGiven(it) {

        const unitOf = unit => {
            switch(unit) {
                case 'D': return 'dia (s)'
                case 'M': return 'mese (s)'
                case 'Y': return 'ano (s)'
                default : return unit
            }
        }

        if(it.duration && it.unit) {
            return `${it.duration} ${unitOf(it.unit)}`
        }
    }

    // function activitiesGiven(field) {
    //     return inventory
    //         .projections
    //         .filter(p => {
    //             const forus = !p.deleted && p.fields.filter(f => f.field === field.id && f.place === field.place)
    //             return forus && forus.length > 0
    //         })
    //         .map(p => p.activity)
    //         .map(id => inventory.activities.find(i => i.id === id))
    // }

    function basisGiven(basis) {
        //console.log(basis)
        switch(basis.name) {
            case 'CONSENT'                    : return 'Consentimento'
            case 'LEGITIMATE_INTEREST'        : return 'Legítimo Interesse'
            case 'CONTRACT'                   : return 'Contrato'
            case 'LEGAL_OBLIGATION'           : return 'Obrigação Legal'
            case 'PUBLIC_POLICY'              : return 'Políticas Públicas'
            case 'RESEARCH'                   : return 'Realização de Estudos e Pesquisas'
            case 'REGULAR_EXERCISE_OF_RIGHTS' : return 'Exercício Regular de Direitos'
            case 'LIFE_PROTECTION'            : return 'Proteção da Vida'
            case 'CREDIT_PROTECTION'          : return 'Proteção ao Crédito'
            case 'HEALTH_PROTECTION'          : return 'Tutela de Saúde do Titular'
        }
        return basis.name
    }

    function editField(field) {
        return () => {
            const target = place.fields.find(f => f.id == field.id)
            //console.log('edit', target, field, place.fields)
            tempField = _.clone(target, true)
            mode      = 'edit' 
            active    = field.id
        }
    }

    function resetTempField() {
        return { id: 0, key: false, required: false, scopes: AllScopes, definition: null, name: null }
    }

    function addField() {
        if(mode === 'edit') {
            mode      = null
            active    = null
            tempField = null
        } else {
            mode      = 'edit'
            active    = 0
            tempField = resetTempField()
        }
    }

    function editing(mode, active, field) {
        return mode === 'edit' && active === field.id
    }

    function merge(place, tmp) {
        const notdeleted = place.fields.filter(f => !f.deleted)
        if(tmp && tmp.id === 0) {
            return [tmp, ...notdeleted]
        } else {
            return notdeleted
        }
    }

    $: fields = merge(place, tempField)
    $: issues = inventory.placeIssues(place)
    //$: console.log('place changed:', place.fields.map(f => f.definition))

</script>
<!--
{place.fields.length} {fields.length}
{#if tempField}
    <div>key: {tempField.key}</div>
    <div>required: {tempField.required}</div>
    <div>scopes: {scopes}</div>
    <div>def: {tempField.definition}</div>
    <div>name: {tempField.name}</div>
    <div>description: {tempField.description}</div>
    <div>natureza: {tempField.nature}</div>
    <div></div>
    <div></div>
{/if}
<div>active   : {active}  </div> 
<div>mode     : {mode}    </div>
<div>detailed : {detailed}</div> 
-->
<Issues {issues}>
    Problemas:
</Issues>
<h2 class="ui header">Campos</h2>
<div class="actions">
    {#if fields.length > 0}
        <div class="ui toggle big grey checkbox" class:disabled={mode === 'edit'}>
            <input type="checkbox" bind:checked={detailed} disabled={mode === 'edit'}>
            <label>Visualização Detalhada</label>
        </div>
    {/if}
    <button class="ui blue button" on:click={addField} disabled={!latest || mode === 'edit'}>
        Adicionar
    </button>
</div>

{#if fields.length > 0}
    <table class="ui padded large table">
        <thead>
            <tr>
                <th class="one   wide">Chave     </th>
                <th class="one   wide">Sensível  </th>
                <th class="two   wide">Escopo    </th>
                <th class="three wide">Campo     </th>
                <th class="five  wide">Atividades</th>
            </tr>
        </thead>
        <tbody>
            {#each fields as field (field.id)}
                <!-- <tr>
                    <td colspan="4">
                        {JSON.stringify(field)}
                    </td>
                </tr> -->
                {#if editing(mode, active, field)}
                    <tr class="edit">
                        <td colspan="5">
                            <FieldEditor
                                {domain}
                                {place} 
                                bind:mode      = { mode      } 
                                bind:active    = { active    } 
                                bind:field     = { tempField }/>
                        </td>
                    </tr>
                {:else}
                    <tr>
                        <td> <!-- Key -->
                            <i  class="circle icon" 
                                class:faded={!field.key}
                                class:outline={!field.key} 
                                class:green={field.key}>
                            </i>            
                        </td>
                        <td> <!-- Required -->
                            <i  class="circle icon" 
                                class:faded={!field.sensitive}
                                class:outline={!field.sensitive} 
                                class:red={field.sensitive}>
                            </i>
                        </td>
                        <td> <!-- Scopes -->
                            <div class="onview">
                                <div class="scope labels">
                                    <FieldScope {field} {detailed}></FieldScope>
                                </div>
                            </div>
                        </td>
                        <td> <!-- All Fields -->
                            {#if !detailed}
                                <div class="ui list">
                                    <div class="item">
                                        <div class="content">
                                            <div class="description annotation-source" data-annotation={ JSON.stringify({ type: "field", name: field.definition || field.name , target: field }) }>{field.definition} {field.name ? ' (' + field.name + ')' : ''}</div>
                                        </div>
                                    </div>
                                </div>
                            {:else}
                                <div class="ui list">
                                    <div class="item" class:faded={!field.definition}>
                                        <div class="content">
                                            <div class="header">Nome</div>
                                            <div class="description">{field.definition}</div>
                                        </div>
                                    </div>
                                    <div class="item" class:faded={!field.name}>
                                        <div class="content">
                                            <div class="header">Nome no relatório</div>
                                            <div class="description">{field.name || '∅'}</div>
                                        </div>
                                    </div>
                                    <div class="item" class:faded={!field.description}>
                                        <div class="content">
                                            <div class="header">Descrição</div>
                                            <div class="description">{field.description || '∅'}</div>
                                        </div>
                                    </div>
                                    <div class="item" class:faded={!field.nature}>
                                        <div class="header">Natureza</div>
                                        <div class="description">{natureGiven(field.nature) || '∅'}</div>
                                    </div>
                                    <div class="item" class:faded={!field.storage}>
                                        <div class="header">Armazenamento</div>
                                        <div class="description">{storageGiven(field.storage) || '∅'}</div>
                                    </div>
                                    <div class="item" class:faded={!field.duration || !field.unit}>
                                        <div class="header">Retenção</div>
                                        <div class="description">{retentionGiven(field) || '∅'}</div>
                                    </div>
                                </div>
                            {/if}
                        </td>
                        <td> <!-- Activities -->
                            {#each inventory.activitiesGiven(field) as activity}
                                <h4 class="ui header">
                                    <div class="content">
                                        {activity.purpose}
                                        <div class="sub header legal">{basisGiven(activity.basis)}</div>
                                    </div>
                                </h4>
                            {/each}            
                        </td>
                    </tr>
                    {#if detailed}
                        <tr class="detail">
                            <td colspan="4"></td>
                            <td>
                                <button class="ui button" disabled={!latest} on:click|preventDefault={editField(field)}>editar</button>
                            </td>
                        </tr>
                    {/if}
                {/if}
            {/each}
        </tbody>
    </table>
{/if}
<style>
    .faded, 
    .item.faded .header,
    .item.faded .description  {
        color: #ccc !important;
    }

    .legal {
        white-space: nowrap;
    }

    tr.detail td {
        border: 0;
    }

    tr {
        vertical-align: top;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .actions > * {
        margin-left: 2em;
    }

    .circle.icon {
        pointer-events: none;
    }

    tr.edit,
    tr.edit td {
        margin: 0;
        padding: 0;
    }
</style>